import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  .ant-popover.alert-status-popconfirm {
    .ant-popover-inner {
      background-color: ${({ theme }) => theme.colors.background};
    }

    .ant-popover-message-icon .anticon {
      color: ${({ theme }) => theme.colors.primary};
    }

    .ant-popover-message-title {
      color: ${({ theme }) => theme.colors.text};
    }

    .ant-popover-inner-content {
      color: ${({ theme }) => theme.colors.text};
    }

    .ant-popover-buttons {
      .ant-btn-default {
        color: ${({ theme }) => theme.colors.text};
        border-color: ${({ theme }) => theme.colors.border};
        background-color: ${({ theme }) => theme.colors.background};

        &:hover {
          color: ${({ theme }) => theme.colors.primary};
          border-color: ${({ theme }) => theme.colors.primary};
        }
      }

      .ant-btn-primary {
        background-color: ${({ theme }) => theme.colors.primary};
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;
